/* eslint-disable prettier/prettier */
import { createSlice } from '@reduxjs/toolkit'

const propertyBasicInfoReducer = createSlice({
    name: 'propertyBasicInfoReducer',
    initialState: {
        propertyBasicInfo:{} ,
    },
    reducers: {
        setPropertyBasicInfo(state, action) {
            state.propertyBasicInfo = action.payload
        }
    },
})

export const { setPropertyBasicInfo} = propertyBasicInfoReducer.actions


export default propertyBasicInfoReducer.reducer